module.exports = __webpack_public_path__ + "media/icons/calendar-735d64ee.svg";